import API from 'services/API';

import { moment } from 'utils';

export default function getContactInfo() {
  return API.request({
    method: 'GET',
    url: '/profile/personalInfo',
    mapper: function (data) {
      data.dateOfBirth = data.dateOfBirth ? moment(data.dateOfBirth) : null;
      data.residenceRegistrationDate = data.residenceRegistrationDate
        ? moment(data.residenceRegistrationDate)
        : null;
      data.dulDate = data.dulDate ? moment(data.dulDate) : null;

      return data;
    },
  });
}
